import { Card, Form, Input, Typography, notification } from "antd";
import "./App.css";
import { useEffect, useState } from "react";
import Paragraph from "antd/es/typography/Paragraph";
import { Link, useNavigate } from "react-router-dom";
import CustomButton from "./components/common/CustomButton";
import { login } from "./api/user";
import authorization from "./utils/auth/authorization";
import CustomTypography from "./components/common/CustomTypography";
import ZentraLogo from "./assets/icons/ZentraLogo";

function Login() {
  const [api, contextHolder] = notification.useNotification();

  const navigate = useNavigate();

  // useEffect(() => {
  //   if (authorization.isLoggedIn()) {
  //     navigate('/reports', { replace: true })
  //   }
  // }, [])

  const validateEmail = (_, value) => {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

    if (!value || emailRegex.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject("Please enter a valid email address");
  };
  const [loading, setLoading] = useState(false);

  const handleLogin = async ({ email, password }) => {
    setLoading(true);

    try {
      console.log(`Logging in with email:${email} and password:${password}...`);
      // navigate("/reports");
      const response = await login(email, password);
      console.log("Login successful", response);
      setLoading(false);
      if (response.status !== "success") return;
      let user = {
        firstName: response.firstName,
        lastName: response.lastName,
        isValid: response.isValid,
        email: response.email,
        role: response.role,
        token: response.token,
      }
      authorization.login(user)
      navigate("/reports");
    } catch (error) {
      console.log("Login failed", error);
      api.error({
        message: error?.message || "Something went wrong",
      });
      setLoading(false);
    }
  };

  return (
    <>
      {contextHolder}
      <div className="auth-page">
      
      <div className="auth-header">
        <ZentraLogo />
      </div>

      <div
        className="auth-layout"
      >
          <h1>Welcome!</h1>
          <Paragraph className="mb-6">
            Please enter your login information to access your account
          </Paragraph>
          <Form
            style={{ paddingTop: "12px" }}
            layout="vertical"
            // autoComplete="off"
            onFinish={handleLogin}
          >
            <Form.Item
              label="Email"
              style={{ marginBottom: 12 }}
              name="email"
              rules={[
                { required: true, message: "Please enter your email" },
                { validator: validateEmail },
              ]}
            >
              <Input
                size="large"
                className="chat-bot-input"
                placeholder="Email Address"
              />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              style={{ marginBottom: 12, marginTop: 16 }}
              rules={[
                { required: true, message: "Please enter your password" },
              ]}
            >
              <Input.Password
                size="large"
                className="chat-bot-input"
                placeholder="Enter Your Password"
              />
            </Form.Item>
           
            <CustomButton
              className="login-btn"
              size="large"
              block
              htmlType="submit"
              loading={loading}
            >
              Login
            </CustomButton>
            {/* <div className="justify-content-end" style={{ textAlign: "right" }}>
              <Link style={{ fontStyle: "italic", color: "#9579E2" }} to="">
                Forgot your Password?
              </Link>
            </div> */}
          </Form>
        {/* </Card> */}
      </div>
      <div className="auth-side-layout">
          <CustomTypography type={"title"} level={3} className="reportHeader">
          Turn <span className="reportHeaderDark">Data </span>Into <span className="reportHeaderDark">Decisions</span>
          </CustomTypography>
          <p className="fontColor">
          Zentra automates bank statement analysis, transforming complex financial data into clear, actionable reports in minutes. Simplify decision-making with detailed insights at your fingertips.
          </p>
          <ul className="fontColor" type='star'>
            <li >
            <span className="reportHeaderDark">Accelerate Loan Approvals:</span> Reduce statement review time by 90%, enabling faster, data-backed decisions.
            </li>
            <li >
            <span className="reportHeaderDark">Enhance Risk Assessment:</span>  Identify financial patterns and potential risks with AI-driven precision.
            </li>
            <li >
            <span className="reportHeaderDark">Boost Portfolio Quality:</span> Improve borrower selection, leading to a 20% reduction in default rates.
            </li>
            <li >
              <span className="reportHeaderDark">Seamless Integration:</span> Integrates effortlessly with your existing lending systems.
            </li>
            <li >
            <span className="reportHeaderDark">Stay Compliant:</span> Ensure all financial decisions align with industry regulations, safeguarding your operations.
            </li>
          </ul>
      </div>
    </div>
    </>
  );
}

export default Login;
